import { channelSlot } from '../promoteSchedule';
import type { SerializedSocialChannel } from '../types';
import { isInXPostsMonth, isXPostsFull } from '../xPostsLimit';
import type { ComposerTiming } from './useComposerDraft';

/**
 * The time of the X post of the Composer: now, the best slot of the X channel, or the picked
 * time. Null when the artist picks a time and did not pick one yet (a draft with no time).
 */
export function composerXPostTime(
  channel: SerializedSocialChannel,
  timing: ComposerTiming,
  pickedAt: string,
  now: Date
): Date | null {
  if (timing === 'now') {
    return now;
  }
  if (timing === 'best') {
    return channelSlot(channel, now);
  }
  if (pickedAt === '') {
    return null;
  }
  const at = new Date(pickedAt);
  return Number.isNaN(at.getTime()) ? null : at;
}

/**
 * True when the X chip is blocked (design x-connector c2): the X channel posts through the API,
 * its account used the X posts of this month, and the post has a time in this month. A time in a
 * later month opens the chip again; a manual X channel (a handle only) never counts.
 */
export function isComposerXMonthBlocked(
  channel: SerializedSocialChannel | undefined,
  timing: ComposerTiming,
  pickedAt: string,
  now: Date = new Date()
): boolean {
  if (channel === undefined || channel.status !== 'connected' || channel.connection === null) {
    return false;
  }
  const usage = channel.xPosts;
  if (!isXPostsFull(usage)) {
    return false;
  }
  const at = composerXPostTime(channel, timing, pickedAt, now);
  return at !== null && isInXPostsMonth(usage, at);
}
